import { useEffect } from 'react'
import s from './Folders.scss'
import { FaFolder } from 'react-icons/fa'
import { useLoading } from 'hooks'
import { makeGetRequest } from 'utils/api'

const Folders = ({ dealId, companyId, folders, setSelectedFolder, setDocuments, documents }) => {
  const [, withLoadingLocks] = useLoading()

  useEffect(() => {
    if (!dealId || !companyId) return
    ;(async () => {
      const response = await withLoadingLocks(
        makeGetRequest(`/v1/deals/${dealId}/documents`, {
          params: {
            companyId
          }
        })
      )
      setDocuments(response)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, dealId])

  return (
    <div className={s.documentsWrapper}>
      {folders.map(folder => (
        <div key={folder.id} className={s.folder} onClick={() => setSelectedFolder(folder)}>
          {documents[folder.id]?.length > 0 && (
            <span className={s.count}>{documents[folder.id]?.length}</span>
          )}
          <FaFolder className={s.folderIcon} />
          <span>{folder.name}</span>
        </div>
      ))}
    </div>
  )
}

export default Folders
